import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getPaymentSettings, patchPaymentSettings } from "../api/payments";
import type { PatchPaymentSettingsRequest } from "../api/payments";
import { usePaymentsSettingsStore } from "../store/paymentsSettingsSlice";

export function usePaymentSettings() {
  return useQuery({
    queryKey: ["paymentSettings"],
    queryFn: getPaymentSettings,
    staleTime: 60_000,
  });
}

export function usePatchPaymentSettings() {
  const qc = useQueryClient();
  const { resetDraft, initDraft } = usePaymentsSettingsStore();

  return useMutation({
    mutationFn: (payload: PatchPaymentSettingsRequest) =>
      patchPaymentSettings(payload),
    onSuccess: (updatedSettings) => {
      qc.invalidateQueries({ queryKey: ["paymentSettings"] });
      resetDraft();
      initDraft(updatedSettings);
    },
  });
}
